import { Helmet } from 'react-helmet-async';

type Props = {
  imageUrls?: string[];
  videoUrls?: string[];
};

export const Preloader = ({ imageUrls, videoUrls }: Props) => {
  if (!imageUrls?.length && !videoUrls?.length) {
    return null;
  }

  return (
    <Helmet>
      {[...new Set(imageUrls)].map(url => (
        <link as="image" key={url} href={url} rel="preload" />
      ))}
      {[...new Set(videoUrls)].map(url => (
        <link as="video" key={url} href={url} rel="preload" />
      ))}
    </Helmet>
  );
};
